<template>
    <div class="leftMenu">       
        <div class="menu-box">
            <div class="m-list m-list-g">
                <h3>我的业务</h3>
                <div class="l-menu" :class="{'isActive': (active==8)}" @click="goPath('/dataContract','01')">数据权属确认</div>
                <div class="l-menu" :class="{'isActive': (active==1)}" @click="goPath('/contract','01')">供应链服务</div>
                <div class="l-menu" :class="{'isActive': (active==5)}" @click="goUrl('/creditorsRights')">债权治理</div>
                <div class="l-menu" :class="{'isActive': (active==6)}" @click="goUrl('/announcement')">公示公告</div>
                <div class="l-menu" :class="{'isActive': (active==7)}" @click="goUrl('/consumption')">消费投资服务</div>
                <div class="l-menu" :class="{'isActive': (active==4)}" @click="goUrl('/preDisposal')">前置处置</div>
                <!-- <div class="l-menu-sub" :class="{'isActive': (curType=='01')}" @click="goPath('/contract','01')">企恒通</div>
                <div class="l-menu-sub no-p">企信通</div>
                <div class="l-menu-sub no-p">企享通</div>
                <div class="l-menu-sub no-p">企转通</div> -->
                <!-- <div class="l-menu-sub" :class="{'isActive': (curType=='02')}" @click="goPath('/contract','02')">企信通</div>
                <div class="l-menu-sub" :class="{'isActive': (curType=='03')}" @click="goPath('/contract','03')">企享通</div>
                <div class="l-menu-sub" :class="{'isActive': (curType=='04')}" @click="goPath('/contract','04')">企转通</div> -->
            </div>
            <div class="m-list m-list-g">
                <h3>我的信息</h3>
                <div class="l-menu" :class="{'isActive': (active==2)}" @click="goPath('/cUser')">用户信息</div>
                <div class="l-menu" :class="{'isActive': (active==3)}" @click="goPath('/changePwd')">信息维护</div>
            </div>
            <!-- <el-collapse v-model="cActive">
                <el-collapse-item name="1">
                    <template slot="title">我的业务</template>
                    <div class="l-menu isActive" @click="goPath('/contract')">业务存证</div>
                </el-collapse-item>
                <el-collapse-item name="2">
                    <template slot="title">我的信息</template>
                    <div class="l-menu" @click="goPath('/cUser')">个人/企业信息</div>
                </el-collapse-item>       
            </el-collapse>                                     -->
        </div>
    </div>
</template>
<script>
export default {
    name: 'leftMenu',
    props: ['active', 'sceneType'],
    data() {
        return {
            cActive: [],
            curType: this.sceneType
        }
    },
    watch: {
        // 监听路由变化
        "$route.query": function(newVal, oldVal) {
            this.curType = newVal.sceneType
        }
    },
    created() {
        this.cActive[0] = this.active+''
    },
    methods: {
        goPath(url, type){
            this.$router.push({path: url, query: {sceneType: type}});
        },
        goUrl(url){
            this.$router.push({path: url});
        }
    }
}
</script>